import isNumeric from 'validator/lib/isNumeric';

import { validateMod11CheckSum } from './validateModService';

const ORGANIZATION_NUMBER_LENGTH = 9;

export const isValidOrganizationNumber = (organizationNumber: string): boolean => {
    return (
        isNumeric(organizationNumber) &&
        organizationNumber.length === ORGANIZATION_NUMBER_LENGTH &&
        validateMod11CheckSum(organizationNumber, false)
    );
};
